"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MrsMorph5_exports = {};
__export(MrsMorph5_exports, {
  MrsMorph5: () => MrsMorph5,
  MrsMorph5Pro: () => MrsMorph5Pro
});
module.exports = __toCommonJS(MrsMorph5_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
var import_helpers = require("./helpers.js");
function morph5Map(mapId, title) {
  return (0, import_core.mapSchemaWithDefaults)({
    mapId,
    title,
    layers: [
      (0, import_topo_map.pointLayer)({
        layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
        title,
        source: (0, import_core.cartographerSourceWithDefaults)({
          layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
          attribution: []
        }),
        defaultAttribute: "preliminaryConditionScore",
        defaultZOrder: "timestamp",
        attributes: [
          (0, import_topo_map.attributeGroup)({
            label: "Survey Details",
            attributes: [
              (0, import_topo_map.stringAttr)({
                attributeId: "riverName",
                label: "River",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "reachName",
                label: "Reach",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "subreachName",
                label: "Subreach",
                buckets: "auto"
              }),
              (0, import_helpers.moduleNumbersAttr)("moduleNumbers"),
              (0, import_topo_map.stringAttr)({
                attributeId: "projectName",
                label: "Project Name",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "projectCode",
                label: "MoRPh Correlation Code",
                buckets: "auto"
              }),
              import_helpers.surveyTypeAttr,
              (0, import_topo_map.teamAttr)("teamId", "Team"),
              (0, import_topo_map.stringAttr)({
                attributeId: "scenarioName",
                label: "Scenario",
                buckets: "auto"
              }),
              (0, import_topo_map.timestampAttr)({
                attributeId: "timestamp",
                label: "Date/Time",
                buckets: "auto"
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "MoRPh Modules",
            attributes: [
              (0, import_topo_map.surveyAttr)("morphSurvey1Id", "Module 1 or 6"),
              (0, import_topo_map.surveyAttr)("morphSurvey2Id", "Module 2 or 7"),
              (0, import_topo_map.surveyAttr)("morphSurvey3Id", "Module 3 or 8"),
              (0, import_topo_map.surveyAttr)("morphSurvey4Id", "Module 4 or 9"),
              (0, import_topo_map.surveyAttr)("morphSurvey5Id", "Module 5 or 10")
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "River Condition",
            attributes: [
              (0, import_topo_map.numberAttr)({
                attributeId: "preliminaryConditionScore",
                label: "Condition Score (Preliminary)",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(-5, -4, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.rangeBucket)(-4, -3, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.rangeBucket)(-3, -2, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.rangeBucket)(-2, -1, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.rangeBucket)(-1, 0, import_topo_map.marker.quality(0.4)),
                  (0, import_topo_map.rangeBucket)(0, 1, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.rangeBucket)(1, 2, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.rangeBucket)(2, 3, import_topo_map.marker.quality(0.7)),
                  (0, import_topo_map.rangeBucket)(3, 4, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.rangeBucket)(4, 5, import_topo_map.marker.quality(0.9))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "PositiveIndexAverage",
                label: "Average of Positive Indicators",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 1, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.rangeBucket)(1, 2, import_topo_map.marker.quality(0.6)),
                  (0, import_topo_map.rangeBucket)(2, 3, import_topo_map.marker.quality(0.7)),
                  (0, import_topo_map.rangeBucket)(3, 4, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.rangeBucket)(4, 5, import_topo_map.marker.quality(0.9))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "NegativeIndexAverage",
                label: "Average of Negative Indicators",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(-5, -4, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.rangeBucket)(-4, -3, import_topo_map.marker.quality(0.1)),
                  (0, import_topo_map.rangeBucket)(-3, -2, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.rangeBucket)(-2, -1, import_topo_map.marker.quality(0.3)),
                  (0, import_topo_map.rangeBucket)(-1, 0, import_topo_map.marker.quality(0.4))
                ]
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Dimensions",
            attributes: [
              (0, import_topo_map.numberAttr)({
                attributeId: "riverShape",
                label: "River Shape",
                decimalPlaces: 3,
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 0.5, import_topo_map.marker.numeric(0 / 6)),
                  (0, import_topo_map.rangeBucket)(0.5, 1, import_topo_map.marker.numeric(1 / 6)),
                  (0, import_topo_map.rangeBucket)(1, 1.5, import_topo_map.marker.numeric(2 / 6)),
                  (0, import_topo_map.rangeBucket)(1.5, 2, import_topo_map.marker.numeric(3 / 6)),
                  (0, import_topo_map.rangeBucket)(2, 5, import_topo_map.marker.numeric(4 / 6)),
                  (0, import_topo_map.rangeBucket)(5, 10, import_topo_map.marker.numeric(5 / 6)),
                  (0, import_topo_map.rangeBucket)(10, null, import_topo_map.marker.numeric(6 / 6))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "averageWidth",
                label: "Average Width",
                decimalPlaces: 3,
                unit: "m",
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 1, import_topo_map.marker.numeric(0 / 6)),
                  (0, import_topo_map.rangeBucket)(1, 2, import_topo_map.marker.numeric(1 / 6)),
                  (0, import_topo_map.rangeBucket)(2, 3, import_topo_map.marker.numeric(2 / 6)),
                  (0, import_topo_map.rangeBucket)(3, 5, import_topo_map.marker.numeric(3 / 6)),
                  (0, import_topo_map.rangeBucket)(5, 10, import_topo_map.marker.numeric(4 / 6)),
                  (0, import_topo_map.rangeBucket)(10, 20, import_topo_map.marker.numeric(5 / 6)),
                  (0, import_topo_map.rangeBucket)(20, null, import_topo_map.marker.numeric(6 / 6))
                ]
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Group A",
            attributes: [
              (0, import_topo_map.booleanAttr)({
                attributeId: "A6",
                label: "A6: Bedrock Reaches",
                buckets: "auto"
              }),
              (0, import_helpers.particleSizeAttr)("A7", "A7: Coarsest Bed Material Size Class", true),
              (0, import_helpers.particleSizeAttr)("A8", "A8: Average Alluvial Bed Material Size Class", false)
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Group B",
            attributes: [
              (0, import_helpers.positiveIndex)("B1", "B1: Bank Top Vegetation Structure"),
              (0, import_helpers.positiveIndex)("B2", "B2: Bank Top Tree Feature Richness"),
              (0, import_helpers.positiveIndex)("B3", "B3: Bank Top Water-Related Features"),
              (0, import_helpers.negativeIndex)("B4", "B4: Bank Top NNIPS Cover"),
              (0, import_helpers.negativeIndex)("B5", "B5: Bank Top Managed Ground Cover")
            ]
          }),
          // attributeGroup({
          //   label: "Group B (Unnormalized)",
          //   attributes: [
          //     numberAttr({ attributeId: "B1U", label: "B1U: Bank Top Vegetation Structure (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "B2U", label: "B2U: Bank Top Tree Feature Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "B3U", label: "B3U: Bank Top Water-Related Features (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "B4U", label: "B4U: Bank Top NNIPS Cover (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "B5U", label: "B5U: Bank Top Managed Ground Cover (Unnormalized)", buckets: "auto" }),
          //   ],
          // }),
          (0, import_topo_map.attributeGroup)({
            label: "Group C",
            attributes: [
              (0, import_helpers.positiveIndex)("C1", "C1: Bank Face Riparian Vegetation Structure"),
              (0, import_helpers.positiveIndex)("C2", "C2: Bank Face Tree Feature Richness"),
              (0, import_helpers.positiveIndex)("C3", "C3: Bank Face Natural Bank Profile Extent"),
              (0, import_helpers.positiveIndex)("C4", "C4: Bank Face Natural Bank Profile Richness"),
              (0, import_helpers.positiveIndex)("C5", "C5: Bank Face Natural Bank Material Richness"),
              (0, import_helpers.positiveIndex)("C6", "C6: Bank Face Bare Sediment Extent"),
              (0, import_helpers.negativeIndex)("C7", "C7: Bank Face Artificial Bank Profile Extent"),
              (0, import_helpers.negativeIndex)("C8", "C8: Bank Face Reinforcement Extent"),
              (0, import_helpers.negativeIndex)("C9", "C9: Bank Face Reinforcement Material Severity"),
              (0, import_helpers.negativeIndex)("C10", "C10: Bank Face NNIPS Cover")
            ]
          }),
          // attributeGroup({
          //   label: "Group C (Unnormalized)",
          //   attributes: [
          //     numberAttr({ attributeId: "C1U", label: "C1U: Bank Face Riparian Vegetation Structure (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C2U", label: "C2U: Bank Face Tree Feature Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C3U", label: "C3U: Bank Face Natural Bank Profile Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C4U", label: "C4U: Bank Face Natural Bank Profile Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C5U", label: "C5U: Bank Face Natural Bank Material Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C6U", label: "C6U: Bank Face Bare Sediment Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C7U", label: "C7U: Bank Face Artificial Bank Profile Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C8U", label: "C8U: Bank Face Reinforcement Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C9U", label: "C9U: Bank Face Reinforcement Material Severity (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "C10U", label: "C10U: Bank Face NNIPS Cover (Unnormalized)", buckets: "auto" }),
          //   ]
          // }),
          (0, import_topo_map.attributeGroup)({
            label: "Group D",
            attributes: [
              (0, import_helpers.positiveIndex)("D1", "D1: Channel Margin Aquatic Vegetation Extent"),
              (0, import_helpers.positiveIndex)("D2", "D2: Channel Margin Aquatic Morphotype Richness"),
              (0, import_helpers.positiveIndex)("D3", "D3: Channel Margin Physical Feature Extent"),
              (0, import_helpers.positiveIndex)("D4", "D4: Channel Margin Physical Feature Richness"),
              (0, import_helpers.negativeIndex)("D5", "D5: Channel Margin Artificial Features")
            ]
          }),
          // attributeGroup({
          //   label: "Group D (Unnormalized)",
          //   attributes: [
          //     numberAttr({ attributeId: "D1U", label: "D1U: Channel Margin Aquatic Vegetation Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "D2U", label: "D2U: Channel Margin Aquatic Morphotype Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "D3U", label: "D3U: Channel Margin Physical Feature Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "D4U", label: "D4U: Channel Margin Physical Feature Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "D5U", label: "D5U: Channel Margin Artificial Features (Unnormalized)", buckets: "auto" }),
          //   ]
          // }),
          (0, import_topo_map.attributeGroup)({
            label: "Group E",
            attributes: [
              (0, import_helpers.positiveIndex)("E1", "E1: Channel Aquatic Morphotype Richness"),
              (0, import_helpers.positiveIndex)("E2", "E2: Channel Bed Tree Features Richness"),
              (0, import_helpers.positiveIndex)("E3", "E3: Channel Bed Hydraulic Features Richness"),
              (0, import_helpers.positiveIndex)("E4", "E4: Channel Bed Natural Features Extent"),
              (0, import_helpers.positiveIndex)("E5", "E5: Channel Bed Natural Features Richness"),
              (0, import_helpers.positiveIndex)("E6", "E6: Channel Bed Material Richness"),
              (0, import_helpers.negativeIndex)("E7", "E7: Channel Bed Siltation"),
              (0, import_helpers.negativeIndex)("E8", "E8: Channel Bed Reinforcement Extent"),
              (0, import_helpers.negativeIndex)("E9", "E9: Channel Bed Reinforcement Severity"),
              (0, import_helpers.negativeIndex)("E10", "E10: Channel Bed Artificial Features Severity"),
              (0, import_helpers.negativeIndex)("E11", "E11: Channel Bed NNIPS Extent"),
              (0, import_helpers.negativeIndex)("E12", "E12: Channel Bed Filamentous Algae Extent")
            ]
          })
          // attributeGroup({
          //   label: "Group E (Unnormalized)",
          //   attributes: [
          //     numberAttr({ attributeId: "E1U", label: "E1U: Channel Aquatic Morphotype Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E2U", label: "E2U: Channel Bed Tree Features Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E3U", label: "E3U: Channel Bed Hydraulic Features Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E4U", label: "E4U: Channel Bed Natural Features Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E5U", label: "E5U: Channel Bed Natural Features Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E6U", label: "E6U: Channel Bed Material Richness (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E7U", label: "E7U: Channel Bed Siltation (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E8U", label: "E8U: Channel Bed Reinforcement Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E9U", label: "E9U: Channel Bed Reinforcement Severity (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E10U", label: "E10U: Channel Bed Artificial Features Severity (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E11U", label: "E11U: Channel Bed NNIPS Extent (Unnormalized)", buckets: "auto" }),
          //     numberAttr({ attributeId: "E12U", label: "E12U: Channel Bed Filamentous Algae Extent (Unnormalized)", buckets: "auto" }),
          //   ]
          // }),
        ]
      })
    ]
  });
}
const MrsMorph5 = morph5Map((0, import_topo_map.unsafeMapId)("mrsMorph5"), "MoRPh5");
const MrsMorph5Pro = morph5Map((0, import_topo_map.unsafeMapId)("mrsMorph5Pro"), "MoRPh5");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MrsMorph5,
  MrsMorph5Pro
});
//# sourceMappingURL=MrsMorph5.js.map
